import { PostWithDetails } from '../models';
import { PostRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetFeedUseCase {
  constructor(private postRepository: PostRepository) {}

  async execute(userId: string, limit: number = 20, offset: number = 0): Promise<PostWithDetails[]> {
    logger.debug('GetFeed', 'Fetching feed', { userId, limit, offset });

    const posts = await this.postRepository.getFeed(userId, limit, offset);

    logger.debug('GetFeed', 'Feed fetched', { count: posts.length });

    return posts;
  }
}
